import { CommandErrorCode } from './command.error-code'

export interface CommandResponse<TErrorCode> {
  readonly errorCode: TErrorCode
  readonly errorCodes: TErrorCode[]
  readonly isSuccessful: boolean
}

export const unsuccessfulCommandResponse: CommandResponse<CommandErrorCode> = {
  errorCode: 'Unsuccessful',
  errorCodes: ['Unsuccessful'],
  isSuccessful: false,
}

export const successfulCommandResponse: CommandResponse<CommandErrorCode> = {
  errorCode: 'Unsuccessful',
  errorCodes: ['Unsuccessful'],
  isSuccessful: true,
}
